import { checkRes } from "../../config";
import checkHeaderOrder from "./checkHeaderOrder";
import checkHeaderCell from "./checkHeaderCell";

const checkHeader = {
  order: {
    [checkRes.failed]: "標頭順序有誤，請依照固定標頭順序填寫。",
    [checkRes.success]: "標頭順序正確",
    checkMethod: checkHeaderOrder,
  },
  content: {
    [checkRes.failed]: "標頭內容有誤。",
    [checkRes.success]: "標頭內容正確",
    checkMethod: checkHeaderCell,
  },
};

export default checkHeader;
